module.exports = __webpack_public_path__ + "img/okko-icon.7820be69.svg";